import { c as _c } from "react/compiler-runtime";
import type { TouchDesignDataPoint, TouchDesignSerie } from '../interfaces';
import { curveSmootherRequirementsSymbol, type CurveSmootherRequirements } from '@/lib/geometry/curve-smoother/curve-smoother.requirements';
import { SmoothStrategy } from '@/lib/geometry/curve-smoother/smooth-strategy.enum';
import { useNamedInjection } from '@/hooks/use-named-injection';
import { useCallback } from 'react';
export const useSmoothedSerieAverage = () => {
  const $ = _c(7);
  const meanSmoother = useNamedInjection(curveSmootherRequirementsSymbol, SmoothStrategy.Mean);
  const medianSmoother = useNamedInjection(curveSmootherRequirementsSymbol, SmoothStrategy.Median);
  const smoothSerie = _temp2;
  let t0;
  if ($[0] !== meanSmoother) {
    t0 = inputSerie_0 => smoothSerie(inputSerie_0, meanSmoother);
    $[0] = meanSmoother;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const smoothMean = t0;
  let t1;
  if ($[2] !== medianSmoother) {
    t1 = inputSerie_1 => smoothSerie(inputSerie_1, medianSmoother);
    $[2] = medianSmoother;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const smoothMedian = t1;
  let t2;
  if ($[4] !== smoothMean || $[5] !== smoothMedian) {
    t2 = {
      smoothMean,
      smoothMedian
    };
    $[4] = smoothMean;
    $[5] = smoothMedian;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
function _temp(dataPoint) {
  return dataPoint.payload;
}
function _temp2(inputSerie, smoother) {
  const inputData = inputSerie.data.map(_temp);
  const smoothedData = smoother.smoothCurve(inputData, undefined);
  const outputData = inputSerie.data.map((dataPoint_0, index) => ({
    ...dataPoint_0,
    payload: smoothedData[index]
  }));
  return {
    ...inputSerie,
    data: outputData
  };
}